import React from 'react';
import { experiences } from './ResumeData';

export function Experience() {
  return (
    <main className="Experience">
      <h2>Professional Experience</h2>
      {experiences.map(item => (
        <article className="card text-start mb-3" key={`${item.title}-${item.company}`}>
          <div className="card-body">
            <h3 className="card-title h5">{item.title}</h3>
            <p><strong>{item.company}</strong> | {item.duration}</p>
            <p>{item.description}</p>
          </div>
        </article>
      ))}
    </main>
  );
}
